import { render, staticRenderFns } from "./ConsultCrud.vue?vue&type=template&id=09043365&"
import script from "./ConsultCrud.vue?vue&type=script&lang=js&"
export * from "./ConsultCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports